import { Close, Visibility, VisibilityOff } from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid2,
  IconButton,
  InputAdornment,
  Modal,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import api from "../../../../services/api";
import { useNotification } from "../../../../componentes/notificationProvider";
import { useEffect, useState } from "react";
import { validarSenha } from "../../../../utils/validateFields";
import { LoadingButton } from "@mui/lab";

export default function ModalEditUserPassword(params) {
  const notify = useNotification();
  const { openEditLoginModal, setOpenEditLoginModal, selectedRow } = params;
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [loading, setLoading] = useState(false);
  //const [permission, setPermission] = useState(null);
  const [hasProfile, setHasProfile] = useState(false);
  //const isSuperAdmin = role === "adm001";

  useEffect(() => {
    //setPermission(selectedRow?.codigoPermissao);
    if (selectedRow?.PerfilCliente) {
      setHasProfile(true);
      return;
    }
    setHasProfile(false);
  }, [selectedRow]);
  const styles = {
    modal: { display: "flex", justifyContent: "center", alignItems: "center" },
    paper: {
      padding: 2,
      maxWidth: "432px",
      width: "90%",
      minWidth: "232px",
      maxHeight: "90vh",
      gap: 2,
      flexDirection: "column",
      display: "flex",
      alignItems: "felx-start",
    },
    boxTitle: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "start",
      alignItems: "center",
      color: "primary.main",
      width: "100%",
    },
    subtitle: {
      fontSize: "14px",
      fontWeight: 500,
      color: "text.primary",
    },
    dialogTitle: {
      padding: 0,
    },
    boxDialogTitle: {
      display: "flex",
      flexDirection: "row",
      gap: 1,
    },
    dialogActions: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "end",
      gap: 0,
      padding: 0,
      width: "100%",
    },
    dialogContent: {
      //flexGrow: 1,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      padding: 0,
      gap: 1.5,
      paddingRight: "5px",
    },
    boxRowFields: {
      display: "flex",
      flexDirection: "column",
      with: "100%",
      gap: 1,
    },
    fotoModalPermission: {
      width: "45px",
      height: "45px",
    },
    textfield: {
      width: "100%",
      minWidth: "min-content",
    },
    name: {
      color: "text.primary",
      fontWeight: 500,
    },
    login: {
      color: "text.secondary",
      fontWeight: 400,
    },
    boxHeader: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      mb: 1,
    },
  };
  const handleUpdatePassword = async () => {
    setIsSubmit(true);
    if (
      !password ||
      !confirmPassword ||
      password !== confirmPassword ||
      !validarSenha(password)
    )
      return;
    const id = selectedRow?.id;

    try {
      setLoading(true);
      const response = await api.put("/usuario/senha/update", {
        id: id,
        senha: password,
        logsLoginClienteId: JSON.parse(localStorage.getItem("logs")).id,
      });

      if (response.data.status === "Error") {
        notify("Error: Não foi possível salvar dados", "error");
      } else {
        handleClose();
        notify("Senha atualizada com sucesso!", "success");
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.error)
        notify(error.response.data.error, "error");
      else notify("Erro ao atualizar dados!", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpenEditLoginModal(false);
    setPassword("");
    setConfirmPassword("");
    setShowPassword(false);
    setShowConfirmPassword(false);
    setIsSubmit(false);
  };

  const handleClickShowPassword = (type) => {
    if (type === "password") {
      setShowPassword((show) => !show);
    } else {
      setShowConfirmPassword((show) => !show);
    }
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleUpdatePassword();
    }
  };

  return (
    <Modal open={openEditLoginModal} onClose={handleClose} sx={styles.modal}>
      <Paper sx={styles.paper}>
        <DialogTitle color="primary" sx={{ padding: 0 }}>
          <Box sx={styles.boxHeader}>
            {!hasProfile ? (
              <Box sx={{ ml: 1 }}>
                <Typography sx={styles.name}>{selectedRow?.email}</Typography>
                <Typography sx={styles.login}>{selectedRow?.login}</Typography>
              </Box>
            ) : (
              <Box sx={styles.boxDialogTitle}>
                <Avatar
                  alt={"foto de perfil"}
                  src={selectedRow?.PerfilCliente?.foto}
                  sx={styles.fotoModalPermission}
                />
                <Box>
                  <Typography sx={styles.name}>
                    {selectedRow?.PerfilCliente?.pessoaFisica
                      ? selectedRow?.PerfilCliente?.nome +
                        selectedRow?.PerfilCliente?.sobrenome
                      : selectedRow?.PerfilCliente?.nomeFantasia}
                  </Typography>
                  <Typography sx={styles.login}>
                    {selectedRow?.login}
                  </Typography>
                </Box>
              </Box>
            )}
            <IconButton
              aria-label="close"
              onClick={() => {
                setOpenEditLoginModal(false);
              }}
            >
              <Close />
            </IconButton>
          </Box>
          <Divider />
        </DialogTitle>
        <DialogContent sx={styles.dialogContent}>
          <Box sx={styles.boxTitle}>
            <Typography fontWeight={500}>Editar Senha</Typography>
          </Box>
          <Grid2 container columnSpacing={1.5} rowSpacing={2}>
            <Grid2 item size={{ xs: 12, sm: 12 }}>
              <Box sx={styles.boxRowFields}>
                {/* <Typography sx={styles.subtitle}>Senha</Typography>{" "} */}
                <TextField
                  placeholder="Digite a senha"
                  size="small"
                  sx={styles.textfield}
                  type={showPassword ? "text" : "password"}
                  autoComplete="off"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  slotProps={{
                    input: {
                      autoComplete: "edit-password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            edge="end"
                            onClick={() => handleClickShowPassword("password")}
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                  error={isSubmit && (!password || !validarSenha(password))}
                  helperText={
                    isSubmit &&
                    (!password || !validarSenha(password)) &&
                    "A senha tem que ter no mínimo 6 dígitos e um número"
                  }
                  disabled={loading}
                />
                <TextField
                  placeholder="Digite a senha novamente"
                  size="small"
                  onKeyDown={handleKeyDown}
                  sx={styles.textfield}
                  type={showConfirmPassword ? "text" : "password"}
                  autoComplete="off"
                  value={confirmPassword}
                  onChange={(e) => {
                    setConfirmPassword(e.target.value);
                  }}
                  slotProps={{
                    input: {
                      autoComplete: "edit-password",
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            edge="end"
                            onClick={() =>
                              handleClickShowPassword("confirmPassword")
                            }
                            onMouseDown={handleMouseDownPassword}
                          >
                            {showConfirmPassword ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    },
                  }}
                  error={
                    isSubmit &&
                    ((password && !confirmPassword) ||
                      password !== confirmPassword)
                  }
                  helperText={
                    isSubmit &&
                    ((password && !confirmPassword) ||
                      password !== confirmPassword) &&
                    "As senhas não conferem!"
                  }
                  disabled={loading}
                />
              </Box>
            </Grid2>
          </Grid2>
        </DialogContent>

        <DialogActions sx={styles.dialogActions}>
          <Button
            onClick={() => {
              handleClose();
            }}
            disabled={loading}
          >
            Cancelar
          </Button>
          <LoadingButton
            variant="contained"
            loading={loading}
            onClick={() => handleUpdatePassword()}
          >
            Salvar
          </LoadingButton>
        </DialogActions>
      </Paper>
    </Modal>
  );
}
